export const ContractType = {
    Indefinite: 'Indefinite',
    Definite: 'Definite'
}

export const ContractTypeFR = {
    Indefinite: 'CDI',
    Definite: 'CDD'
}

export const ContractTypeList = [ContractType.Indefinite, ContractType.Definite]